module.exports = __webpack_public_path__ + "media/assets/ArrowLeftBlue-9191d4346ba59faef558da9e39a5feb9.svg";